import { render, staticRenderFns } from "./Teleconsultation.vue?vue&type=template&id=44fe65db&scoped=true"
import script from "./Teleconsultation.vue?vue&type=script&lang=js"
export * from "./Teleconsultation.vue?vue&type=script&lang=js"
import style0 from "./Teleconsultation.vue?vue&type=style&index=0&id=44fe65db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fe65db",
  null
  
)

export default component.exports